export default __webpack_public_path__ + "static/media/(15).11ecbf97.jpg";